import { isNumberNegative, toBig } from '@talos/kyoko';
import type { CustomerTradeForm } from './types';

export type CustomerTradeValidatedField =
  | 'counterparty'
  | 'marketAccount'
  | 'symbol'
  | 'quantity'
  | 'price'
  | 'amount'
  | 'salesCommission'
  | 'fee'
  | 'feeBPS'
  | 'clTradeID';

export function getCustomerTradeFormFieldErrors(
  form: CustomerTradeForm,
  isEdit: boolean
): Partial<Record<CustomerTradeValidatedField, string>> {
  const errors: Partial<Record<CustomerTradeValidatedField, string>> = {};

  if (!form.counterparty) {
    errors.counterparty = 'Customer is required';
  }
  if (!form.marketAccount) {
    errors.marketAccount = 'Customer Account is required';
  }
  if (!form.symbol) {
    errors.symbol = 'Symbol is required';
  }
  if (!form.quantity) {
    errors.quantity = 'Quantity is required';
  } else if (isNumberNegative(form.quantity)) {
    errors.quantity = 'Quantity must be greater than or equal to 0';
  }
  if (!form.price) {
    errors.price = 'Price is required';
  } else if (isNumberNegative(form.price)) {
    errors.price = 'Price must be greater than or equal to 0';
  }
  if (!form.amount) {
    errors.amount = 'Amount is required';
  } else if (isNumberNegative(form.amount)) {
    errors.amount = 'Amount must be greater than or equal to 0';
  }
  if (form.salesCommission && !toBig(form.salesCommission)) {
    errors.salesCommission = 'Commission must be a number';
  }
  if (form.fee && !toBig(form.fee)) {
    errors.fee = 'Fee must be a number';
  }
  if (form.feeBPS && !toBig(form.feeBPS)) {
    errors.feeBPS = 'Fee BPS must be a number';
  }
  if (!isEdit && !form.clTradeID) {
    errors.clTradeID = 'External ID is required';
  }

  return errors;
}

export function customerTradeFormHasErrors(errors: Partial<Record<CustomerTradeValidatedField, string>>): boolean {
  return Object.keys(errors).length > 0;
}
